import { useEffect, useMemo, useRef } from "react";

const CSP = "default-src 'none'; script-src 'unsafe-inline' 'unsafe-eval' https://cdn.tailwindcss.com https://cdn.jsdelivr.net; " +
  "style-src 'unsafe-inline' https://fonts.googleapis.com https://cdn.jsdelivr.net; font-src https://fonts.gstatic.com data:; " +
  "img-src data: blob: https:; connect-src 'none'; form-action 'none'; base-uri 'none'; frame-src 'none'; worker-src 'none'";

const storageShim = (data) =>
  `(function(){var s=${JSON.stringify(data).replace(/</g, "\\u003c")};function sy(){try{parent.postMessage({__synapsis:1,data:s},'*')}catch(e){}}` +
  `function mk(o,p){var st={getItem:function(k){return Object.prototype.hasOwnProperty.call(o(),k)?o()[k]:null},setItem:function(k,v){o()[k]=String(v);p()},removeItem:function(k){delete o()[k];p()},clear:function(){var x=o();for(var k in x)delete x[k];p()},key:function(i){return Object.keys(o())[i]||null}};Object.defineProperty(st,'length',{get:function(){return Object.keys(o()).length}});return st}` +
  `var ss={};try{Object.defineProperty(window,'localStorage',{value:mk(function(){return s},sy),configurable:true})}catch(e){}` +
  `try{Object.defineProperty(window,'sessionStorage',{value:mk(function(){return ss},function(){}),configurable:true})}catch(e){}})();`;

const errorShim =
  `(function(){function r(m){try{parent.postMessage({__synapsis_err:1,msg:String(m).slice(0,400)},'*')}catch(e){}}` +
  `window.addEventListener('error',function(e){if(e.message)r(e.message+(e.lineno?' (línea '+e.lineno+')':''))});` +
  `window.addEventListener('unhandledrejection',function(e){r('Promesa rechazada: '+(e.reason&&e.reason.message||e.reason))});` +
  `document.addEventListener('securitypolicyviolation',function(e){r('Bloqueado por el entorno aislado: '+e.blockedURI)});` +
  `var ce=console.error;console.error=function(){r(Array.prototype.join.call(arguments,' '));ce.apply(console,arguments)};` +
  `['pushState','replaceState'].forEach(function(f){var o=history[f].bind(history);history[f]=function(st,t,u){try{return o(st,t,u)}catch(e){var x=String(u||'');if(x.indexOf('#')>=0){location.hash=x.slice(x.indexOf('#'))}}}});` +
  `window.SYNAPSIS={submitForm:function(n,d){try{parent.postMessage({__synapsis_form:1,form:String(n||'contacto').slice(0,60),data:JSON.parse(JSON.stringify(d||{}))},'*');return true}catch(e){return false}}};})();`;

function inject(html, data) {
  const tag = `<meta http-equiv="Content-Security-Policy" content="${CSP}"><script>${errorShim}${storageShim(data)}</script>`;
  const m = html.match(/<head[^>]*>/i);
  return m ? html.replace(m[0], m[0] + tag) : tag + html;
}

export const storageKey = (key) => `synapsis:data:${key}`;

export function AppPreview({ html, dataKey, nonce = 0, onRuntime, onForm, className = "", testId = "app-preview-iframe" }) {
  const ref = useRef(null);
  const errs = useRef([]);
  const cb = useRef(onRuntime);
  cb.current = onRuntime;
  const formCb = useRef(onForm);
  formCb.current = onForm;

  const srcDoc = useMemo(() => {
    if (!html) return "";
    let data = {};
    try { data = JSON.parse(localStorage.getItem(storageKey(dataKey)) || "{}"); } catch { data = {}; }
    return inject(html, data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [html, dataKey, nonce]);

  useEffect(() => {
    const onMsg = (e) => {
      if (e.source !== ref.current?.contentWindow) return;
      if (e.data?.__synapsis) localStorage.setItem(storageKey(dataKey), JSON.stringify(e.data.data));
      if (e.data?.__synapsis_form) formCb.current?.(e.data);
      if (e.data?.__synapsis_err && errs.current.length < 30 && !errs.current.includes(e.data.msg)) errs.current.push(e.data.msg);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, [dataKey]);

  useEffect(() => {
    errs.current = [];
    if (!srcDoc) return;
    const t = setTimeout(() => cb.current?.([...errs.current]), 3500);
    return () => clearTimeout(t);
  }, [srcDoc]);

  return (
    <iframe ref={ref} title="Vista previa" data-testid={testId} srcDoc={srcDoc}
      sandbox="allow-scripts allow-forms allow-modals allow-popups"
      className={`w-full h-full bg-white ${className}`} />
  );
}
